import { useCallback, useEffect, useState } from 'react'

import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils/error'

import api from '../../../api/api'

export const useGetGuestPassDetails = (clientId) => {
  const [guestPassDetails, setGuestPassDetails] = useState({
    data: undefined,
    isLoading: false,
  })

  const fetchGuestPassDetails = async () => {
    if (!clientId) {
      return
    }

    setGuestPassDetails((prev) => {
      if (prev.isLoading) return prev
      return { ...prev, isLoading: true }
    })

    try {
      const response = await api.getGuestPassDetailsByClientId(clientId)

      const newData = response.data
      setGuestPassDetails({
        data: newData,
        isLoading: false,
      })
    } catch (error) {
      console.error('Error fetching guest passes:', error)
      setGuestPassDetails((prev) => ({ ...prev, data: undefined, isLoading: false }))
    }
  }

  useEffect(() => {
    if (clientId) {
      fetchGuestPassDetails()
    }
  }, [clientId])

  return guestPassDetails
}

export const useAddGuestPassDetails = (clientId, onCallback, isPoolInfoAvailable, t) => {
  const [isLoading, setIsLoading] = useState(false)

  const fetchCreateGuestPasses = useCallback(
    async (data) => {
      try {
        setIsLoading(true)
        const guestCount = parseInt(data.guestCount)
        const payload = {
          ...data,
          guestCount: isNaN(guestCount) ? 0 : guestCount,
        }

        if (isPoolInfoAvailable) {
          payload.placeId = data.pool.value
        }

        delete payload.pool

        const response = await api.addGuestPassesByClientId(clientId, payload)
        const newData = response.data

        toastFactory.success(t('clients-legacy:visitCreate.addVisitSuccess'))
        setIsLoading(false)
        onCallback(newData.guestPassVisit)
      } catch (error) {
        setIsLoading(false)
        toastFactory.error(error?.response?.data?.message || getApiErrorMessage(error))
      }
    },
    [clientId, onCallback, isPoolInfoAvailable, t],
  )

  return {
    isLoading,
    fetchCreateGuestPasses,
  }
}
